module.exports = __webpack_public_path__ + "static/UNDbg-da8de6ab38656f6f76a25341bbd8767b.jpg";